const compatModules = {};import * as Mod1 from "./discourse/initializers/site-link";
compatModules["discourse/initializers/site-link"] = Mod1;

export * as discourse$initializers$site__link$$__module from "./discourse/initializers/site-link";
export {
default as discourse$initializers$site__link$$default
} from "./discourse/initializers/site-link";
import * as Mod2 from "./discourse/templates/connectors/user-card-metadata/site-link.hbs";
compatModules["discourse/templates/connectors/user-card-metadata/site-link"] = Mod2;

export * as discourse$templates$connectors$user__card__metadata$site__link$$__module from "./discourse/templates/connectors/user-card-metadata/site-link.hbs";
export {
default as discourse$templates$connectors$user__card__metadata$site__link$$default
} from "./discourse/templates/connectors/user-card-metadata/site-link.hbs";
import * as Mod3 from "./discourse/templates/connectors/user-post-names/test.hbs";
compatModules["discourse/templates/connectors/user-post-names/test"] = Mod3;

export * as discourse$templates$connectors$user__post__names$test$$__module from "./discourse/templates/connectors/user-post-names/test.hbs";
export {
default as discourse$templates$connectors$user__post__names$test$$default
} from "./discourse/templates/connectors/user-post-names/test.hbs";
import * as Mod4 from "./discourse/templates/connectors/user-profile-primary/site-link.hbs";
compatModules["discourse/templates/connectors/user-profile-primary/site-link"] = Mod4;

export * as discourse$templates$connectors$user__profile__primary$site__link$$__module from "./discourse/templates/connectors/user-profile-primary/site-link.hbs";
export {
default as discourse$templates$connectors$user__profile__primary$site__link$$default
} from "./discourse/templates/connectors/user-profile-primary/site-link.hbs";
export default compatModules;
